<template>
  <div>
    <div class="static-container">
      <div class="static-block">
        <div class="static-block-title">
          <span>剩余积分</span>
        </div>
        <div class="static-block-value">
          <span>{{pointInfo.point}}</span>
        </div>
      </div>
      <div class="static-block">
        <div class="static-block-title">
          <span>累计使用积分</span>
        </div>
        <div class="static-block-value">
          <span>{{pointInfo.usedPoint}}</span>
        </div>
      </div>
      <div class="static-block">
        <div class="static-block-title">
          <span>累计消费A积分</span>
        </div>
        <div class="static-block-value">
          <span>{{pointInfo.consumeA}}</span>
        </div>
      </div>
      <div class="static-block">
        <div class="static-block-title">
          <span>累计消费B积分</span>
        </div>
        <div class="static-block-value">
          <span>{{pointInfo.consumeB}}</span>
        </div>
      </div>
    </div>

    <div class="search-block">
      <DxTextBox
          :show-clear-button="true"
          placeholder="请输入账单描述"
          @valueChanged="onDescriptionChange"
          width="200"
      />

      <DxSelectBox
          :data-source="billTypeSelect"
          placeholder="账单类型"
          :show-clear-button="true"
          display-expr="text"
          value-expr="value"
          @valueChanged="onBillTypeChange"
          width="200"
      />

      <DxDateBox
          :input-attr="{ 'aria-label': 'Date' }"
          type="date"
          @valueChanged="onStartDateChange"
          placeholder="请选择开始时间"
          width="200"
          :show-clear-button="true"
      />
      <span style="margin-top: 16px">至</span>
      <DxDateBox
          :input-attr="{ 'aria-label': 'Date' }"
          type="date"
          @valueChanged="onEndDateChange"
          placeholder="请选择结束时间"
          width="200"
          :show-clear-button="true"
      />

      <DxButton
          :width="100"
          text="搜索"
          type="success"
          styling-mode="contained"
          @click="list()"
          class="search-block-btn"
      />
    </div>

    <DxTreeList
        id="lists"
        key-expr="id"
        :data-source="datas"
        :show-borders="true"
        :column-auto-width="true"
        :word-wrap-enabled="true"
    >
      <DxColumn
          caption="账单ID"
          data-field="id"
          alignment="center"
      />
      <DxColumn
          caption="点数"
          data-field="point"
          alignment="center"
          cell-template="pointTemplate"
      />

      <template #pointTemplate="{ data: options }">
        <div :style="{color: options.data.billType !== 1 ? 'green' : 'red', 'fontWeight':'bold'}">
          {{ options.data.billType !== 1 ? "+" + options.data.point : "-"+options.data.point }}
        </div>
      </template>

      <DxColumn
          caption="操作前点数"
          data-field="beforePoint"
          alignment="center"
      />
      <DxColumn
          caption="操作后点数"
          data-field="afterPoint"
          alignment="center"
      />
      <DxColumn
          caption="账单类型"
          data-field="billTypeText"
          alignment="center"
      />
      <DxColumn
          caption="创建时间"
          data-field="createTime"
          alignment="center"
      />
      <DxColumn
          caption="账单描述"
          data-field="description"
          alignment="center"
      />
      <DxColumn
          caption="详细内容"
          data-field="details"
          alignment="center"
          cell-template="detailTemplate"
      />
      <template #detailTemplate="{ data: options}">
        <div style="text-align: left">
          <span v-for="(item, index) in options.data.details" :key="index">
            {{item.mark}}（数量：{{item.count}}，积分：{{item.point}}）<br>
          </span>
        </div>
      </template>
    </DxTreeList>
  </div>
</template>

<script>
import {
  DxTreeList,
  DxColumn,
} from 'devextreme-vue/tree-list';

export default {
  components: {
    DxTreeList,
    DxColumn},
  name: "BillPage",
  data(){
    return{
      datas: [],
      searchParams: {
        description: '',
        billType: null,
        startDate: null,
        endDate: null
      },
      billTypeSelect: [
        {text: '支出', value: 1},
        {text: '收入', value: 2},
        {text: '其他', value: 3}
      ],
      pointInfo: {
        point: 0,
        usedPoint: 0,
        consumeA: 0,
        consumeB: 0
      },
    }
  },
  created() {
    this.list()
    this.getPointCountView()
  },
  methods:{
    list(){
      this.$http.viewConsumeBill(this.searchParams).then(res => {
        this.datas = res.data
      })
    },
    getPointCountView(){
      this.$http.getPointCountView().then(res => {
        this.pointInfo = res.data
      })
    },
    onDescriptionChange(e){
      this.searchParams.description = e.value
    },
    onBillTypeChange(e){
      this.searchParams.billType = e.value
    },
    onStartDateChange(e){
      const date = e.value
      this.searchParams.startDate = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`
    },
    onEndDateChange(e){
      const date = e.value
      this.searchParams.endDate = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`
    }
  }
}
</script>

<style scoped>
  #lists {
    max-height: 540px;
  }

  .search-block {
    display: flex;
    gap: 10px;
    margin: 5px 0 5px 5px;
  }

  .static-container {
    display: flex;
    gap: 40px;
    padding: 10px;
  }

  .static-block {
    width: 200px;
    height: 100px;
    border-radius: 10px;
    background-color: white;
  }

  .static-block-title{
    margin-left: 10px;
    margin-top: 20px;
  }

  .static-block-value {
    margin-left: 10px;
    font-weight: bold;
    font-size: 21px;
  }

</style>
